import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Zip Codes", -1)

import EditableDataGrid from '@/components/EditableDataGrid.vue'

	import { defineComponent, Ref, ref } from 'vue';
	import { ZipCode } from '@/interfaces/ZipCode'
	import ZipCodeForm from '@/components/ZipCodeForm.vue'
	import DeleteConfirmationForm from '@/components/DeleteConfirmationForm.vue'
	import { GridColumn } from '@/interfaces/Grid';
	interface Data {
		newItem: Ref<ZipCode>,
		headers: Array<GridColumn>,
		editableEntity: ZipCode,
	}
	const __default__ = defineComponent({
		name: 'ZipCodesView',
		data(): Data {
			const entity = this.getDefaultEntity();
			return {
				newItem: ref(entity),
				headers: [
					{
						title: 'ID',
						sortable: true,
						key: 'id',
						align: 'end',
						width: '50px',
					},
					{ title: 'Code', key: 'code', align: 'start', },
					{ title: 'County', key: 'county', align: 'start', },
					{ title: 'State', key: 'state', align: 'start', },
					{ title: 'City', key: 'city', align: 'start', },
					{ title: 'Area codes', key: 'areaCodes', align: 'start', },
					{ title: 'Actions', key: 'actions', sortable: false, align: 'end', width: '100px' },
				],
				editableEntity: entity,
			}
		},
		methods: {
			getDefaultEntity(): ZipCode {
				return {
					id: 0,
					code: '',
				};
			}
		}
	})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "indigo-darken-3",
              variant: "flat",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newItem = _ctx.getDefaultEntity()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" New Zip code ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(EditableDataGrid, {
      propAddItem: _ctx.newItem,
      "onUpdate:propAddItem": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newItem) = $event)),
      propHeaders: _ctx.headers,
      propController: 'zipcode',
      propEditForm: ZipCodeForm,
      propDeleteForm: DeleteConfirmationForm,
      propDefaultEntity: _ctx.editableEntity
    }, null, 8, ["propAddItem", "propHeaders", "propDefaultEntity"])
  ], 64))
}
}

})